<div class="custom-slider" >
    <div class="slider-bar">
      <div class="slider-progress" [style.width]="sliderValue + '%'"></div>
      <div class="slider-ball" [style.left]="sliderValue + '%'"></div>
    </div>
  </div>
  